import { FormattedMessage } from "react-intl";
import MetaCard from "../MetaCard/MetaCard";

type HasPacemakerProps = {
  hasPacemaker?: boolean;
  compare?: boolean;
};

const HasPacemaker = ({ hasPacemaker, compare }: HasPacemakerProps) => {
  return hasPacemaker ? (
    <MetaCard compare={compare}>
      <div className="font-md">
        <p className="prim-color-dark font-weight-bold mb-0">
          <FormattedMessage
            id="ECG_DETAILS.HAS_PACEMAKER"
            defaultMessage="Has Pacemaker"
          />
        </p>
      </div>
    </MetaCard>
  ) : null;
};

export default HasPacemaker;
